(function () {
  'use strict';

  // Threshold in cents — read from data-threshold-cents (synced to the
  // free_shipping_threshold theme setting); 4500 is only the fallback.
  var THRESHOLD_CENTS = 4500;

  var isDE = (document.documentElement.lang || '').toLowerCase().startsWith('de');

  var shippingMsg = null;
  var strApproaching = '';
  var strUnlocked = '';
  var originalHTML = '';

  function formatAmount(cents) {
    var eur = cents / 100;
    var num = Number.isInteger(eur) ? String(eur) : eur.toFixed(2);
    // German locale: decimal point → comma
    if (isDE) num = num.replace('.', ',');
    return '€' + num;
  }

  function renderBar(totalCents) {
    if (!shippingMsg) return;
    if (totalCents === 0) {
      // Cart empty — restore original static locale content
      shippingMsg.innerHTML = originalHTML;
      return;
    }
    var remaining = THRESHOLD_CENTS - totalCents;
    shippingMsg.textContent = remaining > 0
      ? strApproaching.replace('{amount}', formatAmount(remaining))
      : strUnlocked;
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderBar(cart.total_price); })
      .catch(function () {});
  }

  function init() {
    shippingMsg = document.querySelector('[data-bar-type="shipping"] .announcement-bar__message');
    if (!shippingMsg) {
      // Single-block layout has no [data-bar-type] wrapper — the message
      // itself carries the data attributes.
      shippingMsg = document.querySelector('.announcement-bar__message[data-strategy]');
    }
    if (!shippingMsg) return;

    // Strategy B ('fomo'): shipping is free on every order — the static
    // Liquid-rendered line is always correct, so the dynamic remaining/
    // unlocked swap must stay off.
    if (shippingMsg.dataset.strategy === 'fomo') return;

    var thresholdAttr = parseInt(shippingMsg.dataset.thresholdCents, 10);
    if (thresholdAttr > 0) THRESHOLD_CENTS = thresholdAttr;

    strApproaching = shippingMsg.dataset.approaching || '';
    strUnlocked = shippingMsg.dataset.unlocked || '';
    originalHTML = shippingMsg.innerHTML;

    fetchCart();

    // Hook into Dawn's pub/sub ('cart-update' = PUB_SUB_EVENTS.cartUpdate)
    if (typeof subscribe === 'function') {
      subscribe('cart-update', function (event) {
        if (event && event.cartData) {
          renderBar(event.cartData.total_price);
        } else {
          fetchCart();
        }
      });
    }

    // MutationObserver fallback — fires whenever the cart icon bubble updates
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      new MutationObserver(fetchCart).observe(bubble, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
